import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlBalancete = '/service/balanceteDespesaRestService/'

class ItensPlanoService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    consultar(filtro) {
        let data = {
            administracao: filtro.administracao,
            anoMes: filtro.anoMes,
            codigoFormatado: filtro.codigoFormatado,
        }

        return this.conex.post(urlBalancete + 'itensDetalhamentoLancamento/', JSON.stringify(data))
    }
}

export default ItensPlanoService
